import { render, staticRenderFns } from "./conatcts.vue?vue&type=template&id=0b579c20&"
import script from "./conatcts.vue?vue&type=script&lang=js&"
export * from "./conatcts.vue?vue&type=script&lang=js&"
import style0 from "./conatcts.vue?vue&type=style&index=0&id=0b579c20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports